/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Tlm_3Inputs */

const en_svc_programmatic_seo_tlm_3 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`indexing`)
};

const ar_svc_programmatic_seo_tlm_3 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفهرسة`)
};

const bn_svc_programmatic_seo_tlm_3 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইনডেক্সিং`)
};

const de_svc_programmatic_seo_tlm_3 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indexierung`)
};

const es_svc_programmatic_seo_tlm_3 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indexación`)
};

const fr_svc_programmatic_seo_tlm_3 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indexation`)
};

const pt_svc_programmatic_seo_tlm_3 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indexação`)
};

const zh_svc_programmatic_seo_tlm_3 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收录`)
};

const tr_svc_programmatic_seo_tlm_3 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dizinleme`)
};

const ru_svc_programmatic_seo_tlm_3 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Индексация`)
};

const pl_svc_programmatic_seo_tlm_3 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indeksacja`)
};

/**
* | output |
* | --- |
* | "indexing" |
*
* @param {Svc_Programmatic_Seo_Tlm_3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_tlm_3 = /** @type {((inputs?: Svc_Programmatic_Seo_Tlm_3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Tlm_3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_tlm_3(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_tlm_3(inputs)
	if (locale === "de") return de_svc_programmatic_seo_tlm_3(inputs)
	if (locale === "es") return es_svc_programmatic_seo_tlm_3(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_tlm_3(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_tlm_3(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_tlm_3(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_tlm_3(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_tlm_3(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_tlm_3(inputs)
	return en_svc_programmatic_seo_tlm_3(inputs)
});
export { svc_programmatic_seo_tlm_3 as "svc_programmatic-seo_tlm_3" }